/**
 * Die Tür nach draussen — was den Prüfungsclient beenden darf.
 *
 * **Auftrag des Nutzers, 2026-09-23:** Am Rechner lief die App im Vollbild, und es gab keinen
 * sichtbaren Weg hinaus. Es soll einen geben, aber keinen, den ein Prüfling versehentlich oder
 * absichtlich nimmt: ein Knopf, davor eine Abfrage.
 *
 * Zwei Eingaben kommen durch:
 *
 * 1. **Die PIN aus dem Katalog** (`exit_pin`) — die Einrichtung setzt sie über die
 *    Geräteverwaltung oder die Geräteeinstellungen, und sie kann sie jederzeit ändern.
 * 2. **Der Notfallausweg** — er steht fest in der App und gilt immer. Er ist der Grund, warum
 *    eine vergessene oder verstellte PIN kein Gerät unbrauchbar macht.
 *
 * ⚠️ **Eine leere PIN heisst hier nicht „offen".** Das ist der Unterschied zur Sperre vor den
 * Einstellungen (`sheets/einstellungenSperre.ts`), wo leer wirklich jedem aufmacht: dort steht
 * eine Einstellung dahinter, hier das Ende der Prüfung. Im Werkszustand zählt allein der
 * Notfallausweg.
 *
 * 🔴 **Was das leistet und was nicht.** Der Notfallausweg steht im ausgelieferten Bündel im
 * Klartext; wer dort mit `strings` hineinsieht, findet ihn. Er hält den Prüfling vom
 * Beenden ab, nicht den Entschlossenen vom Rechner. Ein Schloss ist das nicht und soll es
 * nicht sein — es ist der Ausweg, den es geben muss.
 */

/**
 * Der Notfallausweg. Fest verdrahtet, auf Wunsch des Nutzers (2026-09-23).
 *
 * ⛔ **Nicht in eine Einstellung verwandeln.** Genau seine Unveränderlichkeit ist sein Zweck:
 * er soll auch dann noch gelten, wenn eine Geräteverwaltung eine PIN gesetzt hat, die niemand
 * mehr kennt.
 */
export const NOTFALLAUSWEG = 'fair4uftw!';

/**
 * Passt die Eingabe?
 *
 * ⚠️ **An den Rändern wird geschnitten**, auf beiden Seiten — dieselbe Begründung wie bei der
 * Einstellungssperre: das Feld in den Geräteeinstellungen fängt beim Tippen leicht ein
 * Leerzeichen ein, und wer deshalb vor einer verschlossenen Tür steht, hält die App für kaputt.
 */
export function passtBeendenWort(eingabe: string, pin: string): boolean {
  const gegeben = eingabe.trim();
  if (gegeben === '') return false;
  if (gegeben === NOTFALLAUSWEG) return true;

  const erwartet = pin.trim();
  return erwartet !== '' && gegeben === erwartet;
}
